
let state;

export function getState() {
    return state;
}

export function setState(newState) {
    state = Object.freeze(newState);
}
